"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.regexp.exec.js");
var _findParent = require("../mixins/find-parent");
var _util = require("./util");
var _utils = require("../utils");
var _icon = _interopRequireDefault(require("../icon"));
var _loading = _interopRequireDefault(require("../loading"));
var _zzUtils = require("@zz-common/zz-utils");
/* eslint-disable no-else-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable quote-props */

var adapter;
if (!_utils.isServer) {
  adapter = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}

var COMPONENT_NAME = 'z-upload-file';
var STATUS_CLASS_MAP = {
  success: 'z-icon-passed',
  error: 'z-icon-warning-o'
};
var EVENT_CLICK = 'click';
var _default = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "z-upload-file",
      on: {
        "click": _vm.clickHandler
      }
    }, [_vm._t("default", [_c('div', {
      staticClass: "z-upload-file-def",
      style: _vm.fileStyle
    }, [_c('div', {
      staticClass: "z-wrong"
    }, [_c('z-icon', {
      attrs: {
        "name": "zlj-close-o",
        "class-prefix": "zziconfont"
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.removeFile($event);
        }
      }
    })], 1), _c('div', {
      staticClass: "z-upload-file-state",
      class: _vm.fileStatusCls
    }, [_c('i', {
      staticClass: "z-upload-file-status z-icon",
      class: _vm.statusCls
    }), _vm.showLoading ? _c('div', {
      staticClass: "z-upload-file-loading"
    }, [_c('z-loading', {
      attrs: {
        "type": "spinner",
        "color": "#fff"
      }
    })], 1) : _c('span', {
      staticClass: "z-upload-file-progress"
    }, [_vm._v("\n          " + _vm._s(_vm.fileProgress) + "\n        ")])])]), _c('div', {
      staticClass: "z-play",
      style: _vm.iconStatusStyle
    }, [_c('z-icon', {
      staticClass: "z-play-circle-o",
      attrs: {
        "name": "play-circle-o"
      }
    })], 1), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.parent.isShowCoverInfo || _vm.isShowCoverInfo) && _vm.indexKey === 0 && (_vm.file.type && _vm.file.type.indexOf('image') !== -1 || _vm.parent.coverInfoVideo),
        expression: "(parent.isShowCoverInfo || isShowCoverInfo) &&\n        indexKey === 0 &&\n        (file.type && file.type.indexOf('image') !== -1 ||\n          parent.coverInfoVideo)"
      }],
      staticClass: "z-upload-cover"
    }, [_vm._v("\n      " + _vm._s(_vm.parent.coverInfo || _vm.coverInfo) + "\n    ")])], {
      "imgStyle": _vm.fileStyle,
      "progress": _vm.fileProgress
    })], 2);
  },
  name: COMPONENT_NAME,
  components: {
    'z-icon': _icon.default,
    'z-loading': _loading.default
  },
  mixins: [_findParent.FindParentMixin],
  props: {
    file: {
      type: Object,
      required: true
    },
    indexKey: {
      type: Number
    },
    // 以下为兼容参数，下个大版本移除
    coverInfo: {
      type: String,
      default: '主图'
    },
    isShowCoverInfo: {
      type: Boolean,
      default: false
    },
    isShowProcess: {
      type: Boolean,
      default: true
    },
    isShowUploadError: {
      type: Boolean,
      default: true
    },
    isShowUploadSuccess: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showLoading: function showLoading() {
      if (_utils.isServer) return true;
      var useAppUpload = this.parent.zzapp && (adapter.in('zz') || adapter.in('zzstore') || adapter.in('zzseller')) || this.parent.zzhunter && adapter.in('zzhunter') || this.parent.zlj && adapter.in('zlj');
      // 在app中上传的话，会默认隐藏上传百分比，isShowProcess的优先级较低，没法覆盖这个行为。
      // 如果使用者希望自己处理百分比的话，可以使用这个prop来显示百分比，
      // 并监听upload.vue组件的uploading事件，自行修改 File 对象的上传百分比。
      if (this.parent.forceShowProcess) {
        return false;
      }
      var showLoading = useAppUpload || this.parent.isShowProcess && this.isShowProcess;
      return showLoading;
    },
    fileStatusCls: function fileStatusCls() {
      var file = this.file;
      var status = file.status;
      if (file.progress >= 0 && file.progress < 1) {
        return 'z-upload-file_stat';
      } else if (status === _util.STATUS_SUCCESS) {
        if (this.parent.isShowUploadSuccess || this.isShowUploadSuccess) {
          return 'z-upload-file_stat';
        } else {
          return 'z-upload-file_stat-success';
        }
      } else if (status === _util.STATUS_ERROR) {
        if (this.parent.isShowUploadError && this.isShowUploadError) {
          return 'z-upload-file_stat';
        } else {
          return 'z-upload-file_stat-error';
        }
      }
      return '';
    },
    fileStyle: function fileStyle() {
      if (this.file.progress < 1 && !this.file.base64) {
        // 关闭视频背景
        return;
      }
      // 找靓机的封面图没有后缀
      var isPic = /.\.(png|jpg|jpeg|gif|bmp)/i.test(this.file.response) || /https?:\/\/cdn\.huodao\.hk\//i.test(this.file.response);
      var thumb = (0, _zzUtils.setPicSize)(isPic ? this.file.response : '', 160); // 缩略图宽度
      var url = this.parent.dropOriginFile ? !this.file.response ? this.file.base64 : thumb : this.file.base64 || thumb;
      if (!url) {
        return;
      }
      return {
        'background-image': "url(\"" + url + "\")",
        'background-size': this.parent.imageBgSize
      };
    },
    iconStatusStyle: function iconStatusStyle() {
      return {
        'display': this.file.type && this.file.type.indexOf('video') !== -1 && this.file.status === 'success' ? 'block' : 'none'
      };
    },
    statusCls: function statusCls() {
      var status = this.file.status;
      if ((this.parent.isShowUploadSuccess || this.isShowUploadSuccess) && status === 'success') {
        return STATUS_CLASS_MAP[status];
      } else if ((this.parent.isShowUploadError || this.isShowUploadError) && status === 'error') {
        return STATUS_CLASS_MAP[status];
      } else {
        return '';
      }
    },
    fileProgress: function fileProgress() {
      if (this.statusCls) {
        return '100%';
      }
      var p = Math.min(Math.floor(Number(this.file.progress) * 100), 99);
      return p + "%";
    }
  },
  created: function created() {
    if (!_utils.isServer && this.$expandAdapter) adapter = this.$expandAdapter;
    this.findParent('z-upload');
  },
  methods: {
    clickHandler: function clickHandler() {
      this.$emit(EVENT_CLICK, this.file);
    },
    removeFile: function removeFile() {
      this.parent.removeFile(this.file);
    }
  }
};
exports.default = _default;